import styled from 'styled-components';
import BoundSelect from '../../shared/components/boundForm/BoundSelect';
import BoundFormGroup from '../../shared/components/boundForm/BoundFormGroup';

const InputContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50% auto;
  max-width: 100%;
  gap: 10px;
  margin-bottom: 8px;
`;

const authTypeOptions = [
  { value: 'none', label: 'None ' },
  { value: 'basic', label: 'Basic' },
  { value: 'bearer', label: 'Bearer Token' },
];

export function CustomHttpAuth({ form }) {
  return (
    <div style={{ marginBottom: '8px' }}>
      <BoundSelect
        formId={form.id}
        id={'auth_type'}
        onChange={(value) => form.set('auth_type', value)}
        style={{ width: '100%', height: 'auto' }}
        options={authTypeOptions}
        label={'Authentication'}
        helpText={'Authentication type for the request'}
      />
      {form.state.auth_type === 'basic' && (
        <InputContainer>
          <BoundFormGroup
            formId={form.id}
            fields={[
              [
                {
                  id: 'auth_username',
                  label: 'Username',
                  placeholder: 'Username',
                },
              ],
              [
                {
                  id: 'auth_password',
                  label: 'Password',
                  placeholder: 'Password',
                },
              ],
            ]}
          />
        </InputContainer>
      )}
      {form.state.auth_type === 'bearer' && (
        <div style={{ marginBottom: '8px' }}>
          <BoundFormGroup
            formId={form.id}
            fields={[
              [
                {
                  id: 'auth_bearer_token',
                  label: 'Bearer Token',
                  placeholder: 'Bearer Token',
                },
              ],
            ]}
          />
        </div>
      )}
    </div>
  );
}
